/**
 * @generated SignedSource<<c0367b1cbb8a22ea03e84faba7e3db59>>
 * @relayHash 3ed6a55d6b39a49ae6a95619ef16ff61
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4bd6ba9d1b06f3a5def83dee2e069e4810b9ca9e72e61e29df2d401cce168033

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type EntitlementsEntitlementsQuery$variables = {
  cloudId: string;
  organizationId: string;
};
export type EntitlementsEntitlementsQuery$data = {
  readonly customerService: {
    readonly organizationByOrganizationId: {
      readonly __typename: "CustomerServiceOrganization";
      readonly __id: string;
      readonly entitlementList: ReadonlyArray<{
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"Entitlement">;
      }>;
      readonly id: string;
      readonly name: string;
    } | {
      readonly __typename: "QueryError";
      readonly " $fragmentSpreads": FragmentRefs<"ThrowOnQueryError">;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
    readonly productConnections: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: "CustomerServiceProduct";
        } | null;
      }>;
    };
  };
};
export type EntitlementsEntitlementsQuery = {
  response: EntitlementsEntitlementsQuery$data;
  variables: EntitlementsEntitlementsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "organizationId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = [
  {
    "kind": "Variable",
    "name": "organizationId",
    "variableName": "organizationId"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "EntitlementsEntitlementsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v1/*: any*/),
          "concreteType": "CustomerServiceQueryApi",
          "kind": "LinkedField",
          "name": "customerService",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v2/*: any*/),
                "concreteType": "CustomerServiceProductConnection",
                "kind": "LinkedField",
                "name": "productConnections",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "CustomerServiceProductEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "concreteType": "CustomerServiceProduct",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v3/*: any*/)
                          ]
                        }
                      ]
                    },
                    "action": "THROW"
                  }
                ],
                "storageKey": "productConnections(first:1)"
              },
              "action": "THROW"
            },
            {
              "kind": "RequiredField",
              "field": {
                "args": (v4/*: any*/),
                "kind": "LinkedField",
                "name": "organizationByOrganizationId",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "RequiredField",
                        "field": (v6/*: any*/),
                        "action": "THROW"
                      },
                      {
                        "kind": "RequiredField",
                        "field": {
                          "concreteType": "CustomerServiceEntitlement",
                          "kind": "LinkedField",
                          "name": "entitlementList",
                          "plural": true,
                          "selections": [
                            (v6/*: any*/),
                            {
                              "args": [
                                {
                                  "kind": "Literal",
                                  "name": "includeEntityTypeName",
                                  "value": false
                                }
                              ],
                              "kind": "FragmentSpread",
                              "name": "Entitlement"
                            }
                          ]
                        },
                        "action": "THROW"
                      },
                      (v7/*: any*/)
                    ],
                    "type": "CustomerServiceOrganization"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "ThrowOnQueryError"
                      }
                    ],
                    "type": "QueryError"
                  }
                ]
              },
              "action": "THROW"
            }
          ]
        },
        "action": "THROW"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EntitlementsEntitlementsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "CustomerServiceQueryApi",
        "kind": "LinkedField",
        "name": "customerService",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "CustomerServiceProductConnection",
            "kind": "LinkedField",
            "name": "productConnections",
            "plural": false,
            "selections": [
              {
                "concreteType": "CustomerServiceProductEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "CustomerServiceProduct",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v6/*: any*/)
                    ]
                  }
                ]
              }
            ],
            "storageKey": "productConnections(first:1)"
          },
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "organizationByOrganizationId",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "concreteType": "CustomerServiceEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlementList",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "concreteType": "CustomerServiceProduct",
                        "kind": "LinkedField",
                        "name": "product",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v7/*: any*/)
                ],
                "type": "CustomerServiceOrganization"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "identifier"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  },
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "statusCode"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "errorType"
                      }
                    ]
                  }
                ],
                "type": "QueryError"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v6/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4bd6ba9d1b06f3a5def83dee2e069e4810b9ca9e72e61e29df2d401cce168033",
    "metadata": {},
    "name": "EntitlementsEntitlementsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e51e400064a3a88281138b0b26c447f1";

export default node;
